export default __webpack_public_path__ + "static/media/291105576.ad3601a3.png";